'use memo';

import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import Icon from '@/components/Icon/Icon';
import { HStack, VStack } from '@/components/Layout';
import { HeaderTabs } from '@/components/Navigation/HeaderTabs';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { Text } from '@/components/Typography/Text';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { useSuspenseQueryOperationPackageInstance } from './-queries';
export const Route = createFileRoute('/_stacktrace/product-planning-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_layout')({
  component: RouteComponent
});

/**
 * PP オペレーションコア インスタンス詳細のレイアウト。
 *
 * プロダクトスコープ棚卸し（ProductScopeReconciliation）は Step2
 * 「スコープ調整」をデータタブで遂行するため「詳細 / データ」2 タブを持つ
 * （PN「リリースプラン作成」の `_layout.tsx` と同型）。
 */
function RouteComponent() {
  const {
    t
  } = useTranslation(stacktraceNS, {
    keyPrefix: 'productPlanningCore.productScopeReconciliation.instance'
  });
  const params = Route.useParams();
  const {
    instanceId
  } = params;
  const {
    data: instance
  } = useSuspenseQueryOperationPackageInstance(instanceId);
  const tabs = [{
    to: '/product-planning-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/detail',
    params,
    children: t('tabs.detail'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/product-planning-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data',
    params,
    children: t('tabs.data'),
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <VStack className="bg-neutral-fill px-12 pt-4 gap-3">
        <Link to="/product-planning-core">
          <Icon iconName="ChevronRight" text={t('backToCore')} variant="small" right />
        </Link>
        <Text variant="h4">{instance.name}</Text>
        <HStack>
          <HeaderTabs tabs={tabs} aria-label={t('tabs.ariaLabel')} />
        </HStack>
      </VStack>
      <Outlet />
    </div>;
}